
import Vue from "vue";

export default Vue.extend({
  name: "HomePageSection2",

  data: () => ({
    font_btn: "",
    features: [
      {
        img: require("@/assets/pages/home/cardNew1.png"),
        text: "El mundo ha vuelto a entrar en movimiento y con ello las inversiones en la industria de los Viajes y la Hospitalidad requieren muchos profesionales competitivos, capaces de adaptarse a las nuevas exigencias de la industria.",
        link: "",
        btn_text: "Más Información",
        btn_link: "/columbiainstituto",
      },
      {
        img: require("@/assets/pages/home/cardNew2.svg"),
        text: "En Columbia te formamos con los conocimientos para destacar en el mundo de la Aviación Comercial.",
        link: "",
        btn_text: "Más Información",
        btn_link: "/columbiacetpro",
      },
      {
        img: require("@/assets/pages/home/cardNew3.svg"),
        text: "Plataforma en donde encontrarás los mejores programas de extensión que el mercado laboral de hoy solicita y a la cual podrás acceder desde cualquier parte del mundo.",
        link: "",
        btn_text: "Más Información",
        btn_link: "/columbiaonline",
      },
      {
        img: require("@/assets/pages/home/Card4.png"),
        text: "Hemos reunido un equipo de instructores altamente calificados y apasionados que están listos para guiarlos en un viaje lingüístico extraordinario..",
        link: "",
        btn_text: "Más Información",
        btn_link: "/CentroIdiomas",
      }
    ],
  }),

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      if (window.innerWidth > 1650) {
        this.font_btn = "130% !important";
      } else {
        this.font_btn = "110% !important";
      }
    },
  },
});
